import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle-down",
  "use": "icon-triangle-down-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-triangle-down\"><path d=\"M281.47962939 206.4796294l458.28055591 611.0407412L1198.0407412 206.4796294z\" p-id=\"12268\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol